import { checkUserToken, getConfig, UserManager, getAccessTokenOrSignin, setRedirectPage, logoutLocal } from '../lib/OidcHelper';
import { isMode, messageBoxAnswerWait, TripPlannerMode, askForItineraries, isSandboxMode } from "./TripPlannerHelper";

const componentValues = {
  // initial componentValues
  itineraryQueue: [],
  debounceTime: 0,
  productDetail: {},
  hasOidc: false,
  sandboxItinery: [],
  oidcUserManager: null,
  apiHubUrl: '',
};

async function initAddToTripCardBtnListeners() {
  // (re-)create on click listeners on new cards
  console.log('initAddToTripCardBtnListeners 111');
  $('.js-openModalButton').on('click', (evt) => openModalLogic(evt));  // button on product page

  const clickAction = (evt) => {
    console.log('click-!');
    openModalLogic(evt);
    $('.tripmodal__save-bottom').css('display', 'none'); // reset Save button
  };

  $('.js-addtotrip-btn').off('click', clickAction); // remove any existing listeners. Important when logged in as some pages may call initAddToTripCardBtnListeners2 again.
  $('.js-addtotrip-btn').on('click', clickAction);

}


// function initAddToTripCardBtnListeners2() {
//   // create on click listeners on new cards
//   console.log('initAddToTripCardBtnListeners2 js-addtotrip-btn');

//   initAddToTripCardBtnListeners();

// $('.js-openModalButton').on('click', openModalLogic.bind(this));  // button on product page

// $('.js-addtotrip-btn').off('click'); // remove any existing listeners. Important when logged in as some pages may call initAddToTripCardBtnListeners2 again.
// $(document).on('click', '.js-addtotrip-btn', function (evt) {
//   console.log('click!');

//   openModalLogic(evt);
//   // reset save button
//   $('.tripmodal__save-bottom').css('display', 'none'); // reset Save button
// });
// }



async function openModalLogic(evt) { // Add-to-trip button clicked
  getProductDetail(evt); // and store in componentValues.productDetail

  const product = getProduct(evt);
  await runAnalyticsAction("trip_action", "add to trip", componentValues.itineraryQueue, product);

  // Check what tpMode we are in and if we need to sign in
  if (isMode('')) {
    const answer = await messageBoxAnswerWait();
    if (!answer)
      return;
  }
  if (isMode(TripPlannerMode.sandbox)) {
    // Get itineraries from iframe and add to window.usersTrips
    await askForItineraries().then(() => {
      drawModalTrips(window.usersTrips);
      $('#addToTripModal').modal('show');
    });
    return;
  }

  // Save in session storage for after the auth redirect
  sessionStorage.setItem('modalOpen_Add', JSON.stringify(product));

  console.log('check User Token');
  const token = checkUserToken();

  // check if user is logged in
  // const token = await getAccessTokenOrSignin(thisComponent.oidcUserManager);
  if (token === null) {
    console.log('no token.');
    sessionStorage.removeItem('signinPageVisited');
    // send user to login and display AddToTripModal

    const config = getConfig(window.location);
    componentValues.oidcUserManager = new UserManager(config);
    getAccessTokenOrSignin(componentValues.oidcUserManager);  // Should signin. On return Modal will open.

  } else {
    // got a token so show addtotrip modal.
    $('#addToTripModal').modal('show');

    initModal();
  }
}


function getProductDetail(evt) {
  const target = $(evt.target);

  componentValues.productDetail.Id = target.attr('productid');
  componentValues.productDetail.Name = target.attr('productname');
  componentValues.productDetail.Type = target.attr('producttype');
  componentValues.productDetail.Location = target.attr('productlocation');
}


function getProduct() {
  let tripObj = {};
  const productOnPage = document.getElementById("contactAddress");

  // If on product page get product details
  if (productOnPage) {
    tripObj.Id = productOnPage?.getAttribute('productid');
    tripObj.Name = productOnPage?.getAttribute('productname');
    tripObj.Type = productOnPage?.getAttribute('producttype');
    tripObj.Location = productOnPage?.getAttribute('productlocation');
    return tripObj;
  }
  // If from search results get product details
  else if (componentValues.productDetail && Object.keys(componentValues.productDetail).length > 0) {
    tripObj.Id = componentValues.productDetail.Id;
    tripObj.Name = componentValues.productDetail.Name;
    tripObj.Type = componentValues.productDetail.Type;
    tripObj.Location = componentValues.productDetail.Location;
    return tripObj;
  }

  const storedProduct = sessionStorage.getItem('modalOpen_Add');
  if (storedProduct) {
    tripObj = JSON.parse(storedProduct);
  }

  return tripObj;
}



async function runAnalyticsAction(actionId, actionName, itineraryQueue, product) {
  //Initializing the data layer on the window object which already exist
  window.digitalData = window.digitalData || [];
  window.digitalData.account = {};
  window.digitalData.trip = [];
  window.digitalData.tripAction = actionName;

  let user = null;
  if (componentValues.oidcUserManager !== null) {
    user = await componentValues.oidcUserManager.getUser();
  } else {
    console.warn('runAnalyticsAction: oidcUserManager is null.');
  }

  if (user && user.profile) {
    window.digitalData.account.ID = user.profile.sub;
  }

  if (typeof itineraryQueue !== 'undefined' && itineraryQueue.length > 0) {
    itineraryQueue.forEach(id => {
      let tripObj = {};
      const currentRegion = product?.Location;

      const trip = window.usersTrips.find(x => x.id === id);

      tripObj.tripID = id
      if (typeof trip !== 'undefined') {
        tripObj.tripName = trip.name;

        if (typeof trip.regions !== 'undefined' && trip.regions.length > 0) {
          tripObj.regionName = getRegions(trip.regions, currentRegion);
        } else {
          tripObj.regionName = currentRegion;
        }
      } else {
        tripObj.tripName = 'New Trip'
        tripObj.regionName = currentRegion;
      }

      if (product) {
        tripObj.productID = product.Id;
        tripObj.productName = product.Name;
        tripObj.productLocation = product.Location;
        tripObj.productType = product.Type;
      }

      window.digitalData.trip.push(tripObj);
    });
  } else if (product) {
    const tripObj = {};

    tripObj.productID = product.Id;
    tripObj.productName = product.Name;
    tripObj.productLocation = product.Location;
    tripObj.productType = product.Type;

    window.digitalData.trip.push(tripObj);
  }

  trackIfNotLocal(actionId);
}


async function initModal() {

  setRedirectPage();

  componentValues.itineraryQueue = []; // reset Queue
  $('.tripmodal__save-bottom').css('display', 'none'); // reset Save button


  // when Modal opens fetch itineraries from API but not too often
  const theTime = Date.now();

  if (isSandboxMode()) {
    await askForItineraries();


    // TODO: if couldn't get itineraries then show error message


  } else if (theTime - componentValues.debounceTime > 1000) { // don't fetch again unless time has passed
    window.usersTrips = await getItineraries();
  }

  // store time for comparison next run
  componentValues.debounceTime = theTime;

  // check if getItineraries failed
  if (typeof window.usersTrips === 'string' && window.usersTrips === 'failed') {
    // Draw an error message
    return;
  }

  drawModalTrips(window.usersTrips);
}


function getRegions(regions, currentRegion) {
  // Need to add current region as there is no update to the products when new regions are added (saves an api call)
  if (currentRegion && typeof regions !== 'undefined' && !regions.includes(currentRegion)) {
    regions += `,${currentRegion}`;
  }
  if (!regions && currentRegion) {
    regions = currentRegion;
  }

  return regions;
}


function trackIfNotLocal(actionId) {
  if (!window.location.hostname.includes('local')) {
    if (window._satellite && typeof window._satellite.track === 'function') {
      window._satellite.track(actionId);
    }
  } else {
    console.log('analytics run');
  }
}


function drawModalTrips(itineraries) {
  const cardFragment = [];
  if (itineraries && itineraries.length > 0) {
    itineraries.forEach(trip => {
      const id = trip.id;
      const name = trip.name;
      const days = trip.dayCount ? trip.dayCount : 0;
      // placeholder image should never be needed, as a trip can't exist without 1 stop
      const placeholder = 'https://umsaprod.blob.core.windows.net/trip-planner/adelaide-1.jpg';
      const qsSeparator = trip.imageUrl[0] && trip.imageUrl[0].includes('?') ? '&' : '?';
      const fullCrop = qsSeparator + 'w=220&h=110&fit=crop'; //ATDW undocumented cropping
      const halfCrop = qsSeparator + 'w=110&h=110&fit=crop';
      const thirdCrop = qsSeparator + 'w=110&h=55&fit=crop';

      let image1Url = trip.imageUrl[0] ? trip.imageUrl[0] : placeholder;
      let image2Url = '';
      let image3Url = '';
      let column2 = '';

      if (trip.imageUrl.length === 1) {
        // one image provided
        image1Url += fullCrop;
      } else if (trip.imageUrl.length === 2) {
        // two images provided
        image1Url += halfCrop;
        image2Url = trip.imageUrl[1] + halfCrop;
        column2 = `<div class="col">
            <div class="row">
              <img class="trip-card__image trip-card__image--large border-round-left" src="${image2Url}" alt="">
            </div>
          </div>`;
      } else if (trip.imageUrl.length === 3) {
        // three images provided
        image1Url += halfCrop;
        image2Url = trip.imageUrl[1] + thirdCrop;
        image3Url = trip.imageUrl[2] + thirdCrop;
        column2 = `<div class="col">
            <div class="row">
              <img class="trip-card__image trip-card__image--small border-round-left" src="${image2Url}" alt="">
            </div>
            <div class="row">
              <img class="trip-card__image trip-card__image--small border-round-left" src="${image3Url}" alt="">
            </div>
          </div>`;
      }

      const stops = trip.stopCount ? trip.stopCount : 0;
      const description = `${days} days&nbsp;&nbsp;&nbsp;${stops} stops`;

      cardFragment.push(`<div class="col-6 col-md-4 modalcard-col trip-card__wrapper">
          <div class="card trip-card" data-trip-id="${id}">
            <div class="container">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <img class="trip-card__image trip-card__image--large border-round-right" src="${image1Url}" alt="">
                  </div>
                </div>
                ${column2}
              </div>
              <div class="img-overlay">
                <div class="img-overlay__background"></div>
                <button type="button" class="btn btn-secondary img-btn-overlay">
                  ADD TO TRIP
                </button>
              </div>
            </div>
            <div class="card-body trip-card-body">
              <div class="container">
                <div class="row">
                  <p class="trip-card-title">${name}</p>
                </div>
                <div class="row">
                  <p class="trip-card-description">${description}</p>
                </div>
              </div>
            </div>
            <div class="trip-card-overlay">
              <div class="container">
                <div class="row trip-card-overlay__row trip-card-overlay__icon-container">
                  <img src="/static/images/i_check_circle_light.svg" class="added_check_filter_color">
                </div>
                <div class="row trip-card-overlay__row ">
                  <p class="trip-card-overlay__description">Add to trip</p>
                </div>
              </div>
            </div>
          </div>
        </div>`);
    });
  }

  // the Modal needs
  // to count itineararies (if < 50 then add a "Create a new trip" button )
  if (!itineraries || (itineraries.length < 50 && !isSandboxMode()) || (itineraries.length === 0 && isSandboxMode())) {
    cardFragment.push(`<div class="col-6 col-md-4 modalcard-col trip-card__wrapper">
      <div class="card create-card">
        <div class="card-body create-card-body">
          <div class="container create-card-container">
            <div class="row create-card-row create-card-icon-container">
              <img src="/static/images/i_plus_light.svg" class="create-icon-filter-color">
            </div>
            <div class="row create-card-row">
              <p class="create-card-description">Create a new trip</p>
            </div>
          </div>

          <div class="trip-card-overlay">
            <div class="container">
              <div class="row trip-card-overlay__row trip-card-overlay__icon-container">
                <img src="/static/images/i_check_circle_light.svg" class="added_check_filter_color">
              </div>
              <div class="row trip-card-overlay__row ">
                <p class="trip-card-overlay__description">Add to trip</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>`);
  }
  // first clear old Trips from modal
  $('#trips-container').empty();
  $('#trips-container').append(cardFragment.join(""));

  console.log('call initAddToTripCardBtnListeners()');
  initAddToTripCardBtnListeners();
  initListeners();
}


async function getItineraries() {
  let itineraries = '';

  // GET All Itineraries with minimal detail
  const token = await getAccessTokenOrSignin(componentValues.oidcUserManager);
  if (!token) return [];

  const myHeaders = new Headers({
    'accept': 'text/plain',
    'Authorization': token
  });

  await fetch(`${componentValues.apiHubUrl}/api/Itinerary/GetMinimal`, {
    headers: myHeaders
  }).then(response => {
    if (!response.ok) {
      throw new Error(`Network response was not "ok". ${response.status}, ${response.statusText}`);
    }
    return response.json();
  }).then(data => {
    itineraries = data;
  }).catch(error => {
    //console.error('GET failed: ', error);
    console.warn('GET failed, e0001', error);
    if (error.status === 401) {
      console.error("Unauthorized. Need to reset session: ", error.status);
      //TODO: signOut();  // logoutLocal, close and re-init modal
    }
    // This is a fetch API error and not necesarily a login issue.
    itineraries = 'failed';
    // first clear old Trips from modal
    $('#trips-container').empty();
    const apiErrorMessage = `<div class="alert alert-danger" style="font-size: inherit;"><p>Failed to fetch from API. Please try and <a class="sa-signout" href="#">signout</a> and then signin again.</p>
        <p><small>${error}</small></p></div>`;
    $('#trips-container').append(apiErrorMessage);
    $('.sa-signout').on('click', signOut.bind(this));
  });

  return itineraries;
}


async function initListeners() {
  $('[data-trip-id]').on('click', onClickATrip.bind(this));
  $('.create-card').on('click', onClickCreate.bind(this));
}


async function signOut() {
  logoutLocal();  // delete logged in storage
  closeModal();
  // componentValues.oidcUserManager.signoutRedirect();  // logout of id-server
}


// Close Modal
function closeModal() {
  $('#addToTripModal').modal('hide');
  // now reset the buttons before next open
  $('.tripmodal__close-bottom').css('display', 'flex');
  $('.tripmodal__saving-message').css('display', 'none');
}


async function onClickATrip(e) {
  console.log("onClickATrip", e.target);
  const $target = $(e.currentTarget)

  alterItinerariesQueue($target.data('trip-id'), $target);

  // Show Added Overlay
  if ($target.find('.trip-card-overlay.show').length > 0) {
    $target.find('.trip-card-overlay').removeClass('show');
    $('.tripmodal__save-bottom').css('display', 'none');
  } else {
    $target.find('.trip-card-overlay').addClass('show');
    $target.find('.img-overlay').css('opacity', 0);
    $('.tripmodal__save-bottom').css('display', 'flex');
  }

  // Change word close to save
  $('.tripmodal__save').text('Save')
  // if (componentValues.itineraryQueue.length > 0) {
  //   console.log("itineraryQueue", componentValues.itineraryQueue.length);
  //   $('.tripmodal__save-bottom').css('display', 'flex');
  // } else {
  //   console.log("itineraryQueue NOT", componentValues.itineraryQueue.length);
  //   $('.tripmodal__save-bottom').css('display', 'none');
  //   $target.removeClass('show');
  // }
}

// Create a-new-trip button function
async function onClickCreate(e) {
  const $target = $(e.currentTarget)
  // Show Added Overlay
  if ($target.find('.trip-card-overlay.show').length > 0) {
    $target.find('.trip-card-overlay').removeClass('show');
  } else {
    $target.find('.trip-card-overlay').addClass('show');
  }

  // const found = componentValues.itineraryQueue.indexOf(id); // find position of item in array
  const newTripId = '00000000-0000-0000-0000-000000000000';
  alterItinerariesQueue(newTripId, $target);
  // componentValues.itineraryQueue.push('00000000-0000-0000-0000-000000000000');
}


function alterItinerariesQueue(tripId, evtTarget) {
  // find id in array, if exists remove, else add
  const found = componentValues.itineraryQueue.indexOf(tripId); // find position of item in array

  if (found > -1) {
    componentValues.itineraryQueue.splice(found, 1); // remove item from array
  } else {
    componentValues.itineraryQueue.push(tripId);
  }

  if (componentValues.itineraryQueue < 1) {
    $('.tripmodal__save-bottom').css('display', 'none');
    evtTarget.removeClass('show');
  } else {
    $('.tripmodal__save-bottom').css('display', 'flex');
  }
}




export { componentValues, initAddToTripCardBtnListeners, initModal, openModalLogic, signOut, closeModal, getProduct, runAnalyticsAction };
